const saveValueToLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, JSON.stringify(value));
}

const loadValueFromLocalStorage = (key: string, defaultValue: any = undefined):any|undefined => {
    const value = localStorage.getItem(key);
    if (value) {
        return JSON.parse(value);
    }
    return defaultValue;
}

export { saveValueToLocalStorage as saveValue, loadValueFromLocalStorage };